export const parseList = (text) =>
    String(text || "")
        .split(/[,\n]/)
        .map((s) => s.trim())
        .filter(Boolean);
export const parseListByNewLine = (text) =>
    String(text || "")
        .split(/\n/)
        .map((s) => s.trim())
        .filter(Boolean);
